import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { Toaster } from './components/ui/sonner';
import HomeEditorial from './pages/HomeEditorial';
import Organizations from './pages/Organizations';
import LegacyHome from './pages/LegacyHome';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomeEditorial />} />
        <Route path="/organizations" element={<Organizations />} />
        <Route path="/legacy" element={<LegacyHome />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
